/**
 * @desc 邮件回复详情列表
 */
const URL = "/rantion-crm";
import http, { updateResponse } from "@/http";
export function request(
  ticketId: string | number,
  params: API.crm.ticket.pageDetail.Params,
  options?: any,
) {
  return updateResponse(
    http(URL + `/crm/ticket/detail/${ticketId}`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
